<template>
  <div>
    <v-container v-if="!ready">
      <v-layout align-center justify-center row fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
    <v-card class="elevation-12" v-else>
      <v-card-title class="headline font-weight-regular blue-grey white--text">Création de projet</v-card-title>
      <v-card-text>
        <v-form>
          <v-flex sm12 md5>
            <v-text-field
              v-model="form.name"
              label="Nom du projet"
              placeholder="Nom du projet"
              outline
            ></v-text-field>
          </v-flex>
          <v-flex sm12 md5>
            <v-select
              outline
              v-model="form.lang"
              :items="langs"
              placeholder="Langue du mot clé (google)"
              label="Langue du mot clé (google)"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-flex>
          <v-flex sm12 md5>
            <v-autocomplete
              v-model="form.sitecreatorCategory"
              :items="categories"
              label="Catégorie sitecreator"
              item-text="name"
              item-value="id"
              outline
            ></v-autocomplete>
          </v-flex>
          <v-radio-group v-model="form.keywordKind" row>
            <v-radio label="Mot clé classique" value="classic"></v-radio>
            <v-radio label="Semrush" value="semrush"></v-radio>
          </v-radio-group>
          <v-flex sm12 md5>
            <v-text-field
              label="Mot clé en français"
              placeholder="Mot clé en français"
              outline
              v-model="form.frenchKeyword"
          ></v-text-field>
          </v-flex>
          <template v-if="form.keywordKind === 'classic'">
            <v-btn
              color="info"
              class="mt-0 mb-3 ml-0"
              :loading="classicTranslateButtonLoading"
              :disabled="classicTranslateButtonDisabled"
              @click="classicTranslate"
            >Traduire</v-btn>
          </template>
          <template v-else>
            <v-btn
              color="info"
              class="mt-0 ml-0"
              :loading="semrushButtonLoading"
              :disabled="semrushButtonDisabled"
              @click="semrush"
            >Semrush</v-btn>
            <div v-if="semrushResults" class="mt-3">
              <div class="chips">
                <v-chip
                  @click="selectSemrushResult(result.keyword)"
                  v-for="result in semrushResults"
                  :key="result.keyword"
                  outline
                  color="primary"
                  v-bind:class="{ selected: selectedSemrushResult === result.keyword }"
                >{{result.keyword}} ({{result.volume}})
                </v-chip>
              </div>
              <v-btn
                color="info"
                class="my-3 ml-0"
                :loading="semrushTranslateButtonLoading"
                :disabled="semrushTranslateButtonDisabled"
                @click="semrushTranslate"
              >Traduire</v-btn>
            </div>
          </template>
          <v-flex sm12 md5>
            <v-text-field
              v-if="form.targetKeyword !== undefined"
              label="Mot clé dans la langue cible"
              placeholder="Mot clé dans la langue cible"
              outline
              v-model="form.targetKeyword"
            ></v-text-field>
          </v-flex>
        </v-form>
      </v-card-text>
      <v-divider class="mt-5"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :disabled="submitDisabled" @click.prevent.native="submit">Créer le projet</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
  import omit from 'lodash/omit';
  import keywordMixin from "../keywordMixin";
  export default {
    mixins: [keywordMixin],
    data() {
      return {
        form: {
          name: undefined,
          sitecreatorCategory: undefined,
          lang: undefined,
          keywordKind: 'classic',
          frenchKeyword: '',
          targetKeyword: undefined,
        }
      }
    },
    computed: {
      submitDisabled() {
        const keys = Object.keys(this.form);
        return keys.find( key => this.form[key] === undefined || this.form[key].toString().trim() === '') !== undefined;
      },
    },
    methods: {
      async submit() {
        if (this.submitDisabled) return;
        const data = omit(this.form, 'keywordKind');
        const response = await this.$http.post('/api/projects/add', data);
        const project = response.data;
        this.addProject(project);
        this.$router.push({ name: 'ProjectDetail', params: { projectId: project.id } });
      }
    }
  }
</script>
<style scoped>
  /deep/ .theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
    border-width: 1px!important;
  }
  /deep/ .v-chip.v-chip.v-chip--outline.selected {
    background: #b3d4fc !important;
  }
</style>
